import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/hotlistcasino/frontend/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/opt/hotlistcasino/frontend/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleProvider"] */ "/opt/hotlistcasino/frontend/src/contexts/LocaleContext.tsx");
